import React from 'react';

import Layout from '../Layout';
import Header from '../Header';
import Heading from '../Heading';
import HeaderButton from '../HeaderButton';

import SigninForm from './SigninForm';

function Signin() {
  return (
    <Layout
      header={
        <Header
          prompt={i18n.gettext("You don't have an account yet?")}
          button={
            <HeaderButton to="/signup">{i18n.gettext('Register')}</HeaderButton>
          }
        />
      }
    >
      <Heading>{i18n.gettext('Sign in')}</Heading>
      <SigninForm />
    </Layout>
  );
}

export default Signin;
